import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ArrowUpRight, Check, LoaderCircle, ShieldCheck } from "lucide-react";
import { BrandMark } from "./BrandMark";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PayDeposit() {
  const { inquiryId } = useParams();
  const [info, setInfo] = useState(null);
  const [state, setState] = useState("loading");
  const [redirecting, setRedirecting] = useState(false);
  const [payError, setPayError] = useState("");

  useEffect(() => {
    fetch(`${API}/pay/${inquiryId}`)
      .then((response) => (response.ok ? response.json() : Promise.reject()))
      .then((payload) => {
        setInfo(payload);
        setState("ready");
      })
      .catch(() => setState("missing"));
  }, [inquiryId]);

  const pay = async () => {
    setRedirecting(true);
    setPayError("");
    try {
      const response = await fetch(`${API}/pay/${inquiryId}/checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ origin_url: window.location.origin }),
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.detail);
      window.location.href = payload.checkout_url;
    } catch (checkoutError) {
      setPayError(checkoutError.message || "We couldn’t open the payment page. Please try again.");
      setRedirecting(false);
    }
  };

  return (
    <div className="team-shell pay-shell" data-testid="pay-deposit-page">
      <div className="pay-card">
        <BrandMark compact />
        {state === "loading" && <div className="team-empty"><LoaderCircle className="spin" size={18} /> Preparing your reservation…</div>}
        {state === "missing" && <div data-testid="pay-not-found"><h1>Link not active</h1><p>This payment link isn’t active yet. Please reach out to the Pop Social team for a fresh link.</p></div>}
        {state === "ready" && info && (
          <>
            <span className="card-eyebrow">Reserve your date</span>
            <h1 data-testid="pay-host-name">{info.full_name}</h1>
            <p className="pay-meta">{info.event_date} · {info.guest_count} guests · {info.event_type}</p>
            <dl className="pay-figures">
              <div><dt>Planning estimate</dt><dd>${Number(info.estimated_total).toLocaleString()}</dd></div>
              <div className="pay-deposit-line"><dt>Booking deposit due</dt><dd data-testid="pay-deposit-amount">${Number(info.deposit_amount).toLocaleString()}</dd></div>
            </dl>
            {info.deposit_status === "paid" ? (
              <div className="deposit-paid" data-testid="pay-already-paid"><Check size={15} /> This deposit has been paid — your date is reserved.</div>
            ) : (
              <>
                <button type="button" className="button button-primary pay-button" onClick={pay} disabled={redirecting} data-testid="pay-deposit-button">
                  {redirecting ? <><LoaderCircle className="spin" size={16} /> Opening secure checkout…</> : <>Pay deposit securely <ArrowUpRight size={16} /></>}
                </button>
                <span className="pay-secure"><ShieldCheck size={14} /> Secure card payment powered by Stripe</span>
                {payError && <span className="team-gate-error" role="alert" data-testid="pay-error-message">{payError}</span>}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}
